import space from './space';
import z from './z';
import x from './c';
import c from './x';
import left from './left';
import right from './right';
import down from './down';
import rotate from './rotate';

export default {
  space,
  z,
  x,
  c,
  left,
  right,
  down,
  rotate,
};
